/** Zod validation schemas for Billing and Credits endpoints */

import { z } from 'zod'

export const checkoutSessionSchema = z.object({
  packId: z.enum(['starter', 'pro', 'enterprise']).optional(),
  successUrl: z.string().url().optional(),
  cancelUrl: z.string().url().optional(),
})

export const creditBalanceResponseSchema = z.object({
  balance: z.number(),
  dailyFree: z.number(),
  dailyFreeRemaining: z.number(),
})
